<template>
  <div>
    <v-btn
      width="100%"
      :height="height"
      variant="outlined"
      :color="color"
      :disabled="visualization || disabled"
      class="d-flex justify-start"
      @click="onClick"
    >
      <v-row
        justify="start"
        align="center"
      >
        <v-checkbox
          v-model="state"
          :color="color"
          :readonly="visualization"
          hide-details
          @click.stop="onClick"
        />
        <span>
          {{ text }}
        </span>
      </v-row>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

defineOptions({ name: 'TCheckbox' })

const props = withDefaults(defineProps<{
  text?: string
  modelValue?: boolean
  color?: string
  visualization?: boolean
  height?: number
  disabled?: boolean
}>(), {
  text: '',
  modelValue: false,
  color: 'primary',
  visualization: false,
  height: 35,
  disabled: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const state = ref(props.modelValue)

watch(() => props.modelValue, (v) => {
  state.value = v
})

function onClick(): void {
  state.value = !state.value
  emit('update:modelValue', state.value)
}
</script>
